import { useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import { format, parseJSON } from "date-fns";
import nlBE from "date-fns/locale/nl-BE";
import "react-datepicker/dist/react-datepicker.css";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import LeaveForbiddenWeekModel from "../Models/LeaveForbiddenWeekModel";
import LeaveRequestService from "../Services/LeaveRequestService";

interface LeaveForbiddenWeekModalProps {
  forbiddenWeek: LeaveForbiddenWeekModel | null;
  afterSave: Function;
  afterCancel: Function;
}

const LeaveForbiddenWeekModal = (props: LeaveForbiddenWeekModalProps) => {
  const { instance } = useMsal();

  const leaveRequesService = useMemo(
    () => new LeaveRequestService(instance),
    [instance]
  );

  const [start, setStart] = useState<Date>(
    props.forbiddenWeek?.start !== undefined
      ? parseJSON(props.forbiddenWeek?.start ?? "")
      : new Date()
  );
  const [end, setEnd] = useState<Date>(
    props.forbiddenWeek?.end !== undefined
      ? parseJSON(props.forbiddenWeek?.end ?? "")
      : new Date()
  );
  const [visible, setVisible] = useState<boolean>(true);

  registerLocale("nlBE", nlBE);

  function handleStartChange(date: Date) {
    setStart(date);
  }

  function handleEndChange(date: Date) {
    setEnd(date);
  }

  function modalToggle() {
    setVisible(!visible);
    props.afterCancel();
  }

  async function modalSave() {
    try {
      await leaveRequesService.upsertForbiddenWeek({
        id: props.forbiddenWeek?.id,
        start: format(start, "yyyy-MM-dd"),
        end: format(end, "yyyy-MM-dd"),
      });

      setVisible(false);
      props.afterSave();
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  return (
    <Modal isOpen={visible} toggle={modalToggle}>
      <ModalHeader toggle={modalToggle}>Verlof verboden week</ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label className="my-1 mr-2">Van</label>
            <DatePicker
              locale="nlBE"
              selected={start}
              onChange={handleStartChange}
              dateFormat="dd/MM/yyyy"
              customInput={
                <input
                  type="text"
                  className="form-control my-1 mr-sm-2"
                  title="Van"
                />
              }
            />
          </div>
          <div className="form-group">
            <label className="my-1 mr-2">Tot en met</label>
            <DatePicker
              locale="nlBE"
              selected={end}
              onChange={handleEndChange}
              dateFormat="dd/MM/yyyy"
              customInput={
                <input
                  type="text"
                  className="form-control my-1 mr-sm-2"
                  title="Tot en met"
                />
              }
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={modalSave}>
          Bewaren
        </Button>{" "}
        <Button color="secondary" onClick={modalToggle}>
          Sluiten
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LeaveForbiddenWeekModal;
